module.exports = __webpack_public_path__ + "static/media/bandit_boots.ebcbec6e.png";